import { Container } from "@/components/container";

export default function Infrastructure() {
  return (
    <div>
      <section className="bg-secondary/50 border-b">
        <Container className="py-12 md:py-16">
          <h1 className="text-3xl md:text-4xl font-semibold">Infrastructure & Networking</h1>
          <p className="mt-3 text-muted-foreground max-w-2xl">
            Secure, performant networks and resilient infrastructure—on‑prem, cloud, or hybrid.
          </p>
        </Container>
      </section>
      <Container className="py-12 md:py-16 grid gap-10 md:grid-cols-3">
        <div className="md:col-span-2 space-y-6">
          <Section title="The problem">
            Ad-hoc networks and aging hardware lead to outages, security gaps, and poor performance
            for staff and customers.
          </Section>
          <Section title="Our solution">
            Standards-based design, modern hardware, zero-trust principles, monitoring, and
            documented operations.
          </Section>
          <Section title="Expected outcomes">
            • Higher uptime • Faster networks • Reduced security risk • Clear documentation
          </Section>
        </div>
        <aside className="space-y-4">
          <h3 className="font-semibold">Deliverables</h3>
          <ul className="text-sm text-muted-foreground space-y-2 list-disc pl-5">
            <li>Network and infra assessment</li>
            <li>Target architecture and BOM</li>
            <li>Implementation plan</li>
            <li>Monitoring and alerting setup</li>
            <li>Runbooks and documentation</li>
          </ul>
        </aside>
      </Container>
    </div>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div className="space-y-2">
      <h2 className="text-xl font-semibold">{title}</h2>
      <p className="text-muted-foreground leading-relaxed">{children}</p>
    </div>
  );
}
